const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
      
      // Log performance metrics
      console.log('Performance Metrics:', {
        CLS: 'Cumulative Layout Shift',
        FID: 'First Input Delay',
        FCP: 'First Contentful Paint',
        LCP: 'Largest Contentful Paint',
        TTFB: 'Time to First Byte'
      });
    });
  }
};

export default reportWebVitals;
